import styled from 'styled-components';
import { PropertyCardBodyMixin } from '../../mixins/components/PropertyCardBodyMixin';
import { Card } from '../Card/Card';
export var StyledPropertyCardBody = /*#__PURE__*/styled(Card).withConfig({
  displayName: "StyledPropertyCardBody",
  componentId: "c11n-8-111-1__sc-1danayh-0"
})(["", ""], PropertyCardBodyMixin);